import {
  createProjectGroupsScenarios,
  deleteProjectGroupsScenariosById,
  readProjectGroupsScenarios,
  readProjectGroupsScenariosById,
  updateProjectGroupsScenariosById,
} from "@/services/api/scenario";
import {
  CreateProjectGroupsScenariosRequest,
  UpdateProjectGroupsScenariosByIdRequest,
} from "@/types/scenario";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../queryKeys";

// 시나리오 분석 생성
export const useCreateProjectGroupsScenarios = (group_id: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateProjectGroupsScenariosRequest) =>
      createProjectGroupsScenarios({ group_id, data }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.SCENARIO.LIST(group_id),
      });
    },
  });
};

// 시나리오 분석 목록 조회
export const useReadProjectGroupsScenarios = (group_id: string) => {
  return useQuery({
    queryKey: QUERY_KEYS.SCENARIO.LIST(group_id),
    queryFn: () => readProjectGroupsScenarios({ group_id }),
  });
};

// 시나리오 분석 상세 조회
export const useReadProjectGroupsScenariosById = (
  group_id: string,
  scenario_id: string
) => {
  return useQuery({
    queryKey: QUERY_KEYS.SCENARIO.DETAIL(group_id, scenario_id),
    queryFn: () => readProjectGroupsScenariosById({ group_id, scenario_id }),
    enabled: !!group_id && !!scenario_id,
  });
};

// 시나리오 분석 수정
export const useUpdateProjectGroupsScenariosById = (
  group_id: string,
  scenario_id: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateProjectGroupsScenariosByIdRequest) =>
      updateProjectGroupsScenariosById({ group_id, scenario_id, data }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.SCENARIO.DETAIL(group_id, scenario_id),
      });
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.SCENARIO.LIST(group_id),
      });
    },
  });
};

// 시나리오 분석 삭제
export const useDeleteProjectGroupsScenariosById = (
  group_id: string,
  scenario_id: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      deleteProjectGroupsScenariosById({ group_id, scenario_id }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.SCENARIO.LIST(group_id),
      });
    },
  });
};
